import React from 'react';
import PropTypes from 'prop-types';

function Linkedin({ size, stroke, fill = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      {...otherProps}
    >
      <path d="M14.4499 9.20022C13.8538 9.19818 13.2631 9.3137 12.7117 9.54017C12.1602 9.76665 11.6589 10.0996 11.2363 10.5201C10.8136 10.9405 10.4781 11.4402 10.2488 11.9904C10.0195 12.5407 9.90092 13.1308 9.8999 13.7269V18.3002C9.8999 18.4859 9.97365 18.6639 10.1049 18.7952C10.2362 18.9265 10.4143 19.0002 10.5999 19.0002H12.2332C12.4189 19.0002 12.5969 18.9265 12.7282 18.7952C12.8595 18.6639 12.9332 18.4859 12.9332 18.3002V13.7269C12.9331 13.5149 12.9776 13.3052 13.0639 13.1115C13.1502 12.9179 13.2764 12.7446 13.4342 12.603C13.592 12.4613 13.7778 12.3545 13.9796 12.2895C14.1814 12.2246 14.3947 12.2028 14.6055 12.2258C14.9835 12.2734 15.3309 12.4581 15.5817 12.7448C15.8326 13.0315 15.9696 13.4004 15.9666 13.7813V18.3002C15.9666 18.4859 16.0403 18.6639 16.1716 18.7952C16.3029 18.9265 16.4809 19.0002 16.6666 19.0002H18.2999C18.4856 19.0002 18.6636 18.9265 18.7949 18.7952C18.9262 18.6639 18.9999 18.4859 18.9999 18.3002V13.7269C18.9989 13.1308 18.8803 12.5407 18.651 11.9904C18.4217 11.4402 18.0862 10.9405 17.6635 10.5201C17.2409 10.0996 16.7396 9.76665 16.1881 9.54017C15.6367 9.3137 15.046 9.19818 14.4499 9.20022Z" />
      <path d="M7.8 9.90039H5.7C5.3134 9.90039 5 10.2138 5 10.6004V18.3004C5 18.687 5.3134 19.0004 5.7 19.0004H7.8C8.1866 19.0004 8.5 18.687 8.5 18.3004V10.6004C8.5 10.2138 8.1866 9.90039 7.8 9.90039Z" />
      <path d="M6.75 8.5C7.7165 8.5 8.5 7.7165 8.5 6.75C8.5 5.7835 7.7165 5 6.75 5C5.7835 5 5 5.7835 5 6.75C5 7.7165 5.7835 8.5 6.75 8.5Z" />
    </svg>
  );
}

Linkedin.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Linkedin;
